"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles = {
    global: {
        'html, body, #root': {
            height: '100%',
            margin: '0',
        },
        body: {
            fontFamily: 'body',
            color: 'chakra-body-text',
            bg: 'chakra-body-bg',
            transitionProperty: 'background-color',
            transitionDuration: 'normal',
            lineHeight: 'base',
        },
        '.form-viewer': {
            bg: '#FDFDFD',
        },
        '.form-builder': {
            bg: 'gray.100',
        },
    },
};
exports.default = styles;
